import { API_URL_V3 } from "../../data/config";

const Call = (path, method = 'GET', data = {}, fullUrl, headers = {}) => {
    const options = {
        method,
        headers: headers
    }

    const token = localStorage.getItem('token');

    if (token) options.headers['x-user-token'] = token;

    if (method === 'POST' || method === 'PUT') {
        options.body = JSON.stringify(data);

        options.headers['Content-type'] = 'application/json';
    }

    const url = fullUrl ? path : `${API_URL_V3}${path}`;

    return fetch(url, options).then(response => {
        if (response.status === 401) {
            localStorage.removeItem('token');
            window.location.reload();
        }

        if (response.ok) return response.json();

        return {};
    }).catch((error) => {
        console.error(error);

        return {};
    });
};

export default Call;



// WEBPACK FOOTER //
// ./src/services/API/Call.v3.js